import { useContext } from "react";
import { SharedTransmitterContext } from "./SharedTransmitterContext";

const useSharedTransmitter = () => useContext(SharedTransmitterContext);

export default useSharedTransmitter;
